/* The editorial hero shares the existing catalogue and search URL builder. */
(() => {
  'use strict';
  function init(root) {
    if (root.dataset.finderReady) return;
    root.dataset.finderReady = 'true';
    const form = root.querySelector('[data-tyre-search-form]');
    const input = root.querySelector('[data-finder-quick-input]');
    const error = root.querySelector('[data-finder-quick-error]');
    const selectedVehicle = () => form.dataset.lockedVehicle || form.querySelector('.vehicle-tabs input:checked')?.value || 'auto';
    function syncVehicle() {
      const vehicle = selectedVehicle();
      root.dataset.vehicle = vehicle;
      root.querySelectorAll('[data-finder-copy]').forEach(node => { node.hidden = node.dataset.finderCopy !== vehicle; });
      root.querySelectorAll('[data-finder-photo]').forEach(node => {
        const active = node.dataset.finderPhoto === vehicle;
        if (active) {
          const image = node.querySelector('img');
          if (image.dataset.src) {
            image.srcset = image.dataset.srcset;
            image.src = image.dataset.src;
            delete image.dataset.src;
          }
        }
        node.hidden = !active;
      });
      const popular = root.querySelector('[data-finder-auto-sizes]');
      if (popular) popular.hidden = vehicle !== 'auto';
      if (root.hasAttribute('data-vehicle-landing')) {
        const placeholder = root.dataset[`${vehicle}Placeholder`];
        if (placeholder) input.placeholder = placeholder;
        root.querySelector('[data-vehicle-category-note]').hidden = !form.dataset.lockedVehicle;
      }
      const examples = {auto:['205','55','16'], moto:['120','70','17'], truck:['225','65','16']};
      ['width','height','rim'].forEach((key,index) => {
        root.querySelectorAll(`[data-finder-example="${key}"]`).forEach(node => {node.textContent = (key === 'rim' ? 'R' : '') + examples[vehicle][index];});
      });
    }
    form.addEventListener('change', event => {
      if (event.target.closest('.vehicle-tabs')) syncVehicle();
    });
    syncVehicle();
    function quickSearch() {
      const raw = input.value.trim();
      const ean = raw.replace(/\s/g, '');
      const size = raw.match(/^(\d{2,3}(?:[.,]\d+)?)\s*\/\s*(\d{1,3})\s*(?:ZR|R|-)\s*(\d{2}(?:[.,]\d+)?)(?:\s*(?:CP|C|M\/C))?(?:\s*\d{2,3}(?:\/\d{2,3})?\s*\(?[A-Z]\)?)?\s*$/i)
        || raw.match(/^(\d{2,3})\s+(\d{1,3})\s+(\d{2})$/);
      let url;
      if (/^(?:\d{8}|\d{12,14})$/.test(ean)) {
        url = new URL(window.gommaDOT?.routes.search || '/search', location.origin);
        const query = form.dataset.lockedVehicle ? `${ean} AND tag:${form.dataset.lockedVehicle}` : ean;
        url.search = new URLSearchParams({ q: query, type: 'product', 'options[prefix]': 'none' }).toString();
      } else if (size && window.GommaDotTyreSearch) {
        const dimensions = size.slice(1, 4).map(v => String(Number(v.replace(',', '.'))));
        const vehicle = selectedVehicle();
        const rows = form._catalog?.rows.filter(row => row[0] === vehicle && dimensions.every((v, i) => v === String(Number(row[i + 1])))) || [];
        // Use only metafield facets supported by the matching catalogue rows.
        const mask = rows.length ? rows.reduce((value, row) => value & row[8], 7) : 0;
        url = window.GommaDotTyreSearch.searchUrl(...dimensions, vehicle, mask);
      }
      error.hidden = Boolean(url);
      input.setAttribute('aria-invalid', String(!url));
      if (url) location.assign(url.toString());
      else input.focus();
    }
    root.querySelector('[data-finder-quick-submit]').addEventListener('click', quickSearch);
    input.addEventListener('keydown', event => {
      if (event.key === 'Enter') { event.preventDefault(); event.stopPropagation(); quickSearch(); }
    });
    input.addEventListener('input', () => { error.hidden = true; input.removeAttribute('aria-invalid'); });
    root.querySelector('[data-finder-ean-mode]').addEventListener('click', () => {
      input.placeholder = input.dataset.eanPlaceholder;
      input.focus();
    });
    [['help', 'help'], ['eu', 'eu']].forEach(([trigger, name]) => {
      const dialog = root.querySelector(`[data-finder-${name}]`);
      const button = root.querySelector(`[data-finder-${trigger}-open]`);
      button?.addEventListener('click', () => dialog.showModal());
      dialog.querySelector('[data-finder-dialog-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
    });
  }
  const initAll = () => document.querySelectorAll('[data-finder-showcase]').forEach(init);
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
